import {useGetMeasurementUnitQuery} from "../../store/backend-api/backend.api";
import {useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {MeasurementUnitFormRead} from "../../components/measurement-unit/form/MeasurementUnitFormRead";

export function ReadMeasurementUnitForm() {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetMeasurementUnitQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    return (<div key={key}>
        {isSuccess && (<MeasurementUnitFormRead data={data}/>)}
    </div>)
}